import React from 'react'
import { useTranslation } from 'react-i18next'

type Props= {
    label:string,
    height?:number
}

export default function SubmitButton({label,height}:Props) {
  const {t} = useTranslation();
  return (
    <div className="">
        <button type="submit" className={`bg-primaryButton text-white px-6 py-2 ${height?`h-[${height}px]`:"h-[44px]"} text-xl 
        transition w-full rounded-[8px] capitalize font-semibold hover:bg-opacity-85`}>
            {t(label)}
        </button>
    </div>
  )
}
